import Credibility from './Credibility';
import GeneralInfo from './GeneralInfo';
import JobTasks from './JobTasks';
import Sales from './Sales';
import Summary from './Summary';

export {
  Credibility,
  GeneralInfo,
  JobTasks,
  Sales,
  Summary
};



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/index.js